import {translate} from 'iss/strings';

export function formatSiteAddress({streetAddress, postCode, city}) {
  return streetAddress + " " + postCode + " " + city;
}

export function formatLocationAddress({address, city}) {
  return address + " " + city;
}

export function formatLocationNameAndCode({name, code}) {
  return code ? name + " (" + code + ")" : name;
}

export function formatSiteExternalId(id) {
  return id == null ? '' : translate('evaluationActivator.siteExternalId') + " " + id;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/format/Site.js